// webpack4 は package.json の exports を解決できないため dist を直接指定する
// CSS は _vendor/_photoswipe.scss として site.scss 側で読み込む
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';

// テンプレート共通の1px線アイコン
const ICON_ARROW_SVG = '<svg class="pswp__icn" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5m6-6-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const ICON_CLOSE_SVG = '<svg class="pswp__icn" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></svg>';
const ICON_ZOOM_SVG = '<svg class="pswp__icn" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="1"/><path d="M15.8 15.8L20 20" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path class="pswp__zoom-icn-bar-h" d="M8.5 11h5" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path class="pswp__zoom-icn-bar-v" d="M11 8.5v5" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"/></svg>';

function getElementSize(element) {
  const [width, height] = (element.getAttribute('data-size') || '').split('x');

  return {
    width: Number(width) || Number(element.dataset.pswpWidth) || 0,
    height: Number(height) || Number(element.dataset.pswpHeight) || 0
  };
}

function getCaptionHTML(element) {
  const caption = element.querySelector('.js-pswp-caption');
  return caption ? caption.innerHTML : '';
}

export function initPhotoSwipeFromDOM(gallerySelector) {
  const galleries = document.querySelectorAll(gallerySelector);
  if (!galleries.length) {
    return;
  }

  const lightbox = new PhotoSwipeLightbox({
    gallery: gallerySelector,
    children: '.js-pswp-element',
    pswpModule: PhotoSwipe,
    allowPanToNext: true,
    spacing: 0.12,
    bgOpacity: 1,
    loop: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
    hideAnimationDuration: 0,
    showAnimationDuration: 0,
    escKey: true,
    arrowKeys: true,
    zoom: true,
    clickToCloseNonZoomable: true,
    imageClickAction: 'zoom-or-close',
    bgClickAction: 'close',
    tapAction: 'toggle-controls',
    doubleTapAction: 'zoom',
    arrowPrevSVG: ICON_ARROW_SVG,
    arrowNextSVG: ICON_ARROW_SVG,
    closeSVG: ICON_CLOSE_SVG,
    zoomSVG: ICON_ZOOM_SVG
  });

  lightbox.addFilter('domItemData', (itemData, element, linkEl) => {
    const source = linkEl || element;
    const { width, height } = getElementSize(source);

    itemData.src = source.dataset.pswpSrc || source.getAttribute('href');
    itemData.width = width;
    itemData.height = height;
    itemData.w = width;
    itemData.h = height;
    itemData.title = getCaptionHTML(source);

    const thumb = source.querySelector('.js-pswp-img, img');
    if (thumb) {
      itemData.msrc = thumb.currentSrc || thumb.src;
      itemData.alt = thumb.getAttribute('alt') || '';
    }

    return itemData;
  });

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'caption',
      className: 'pswp__caption pswp__hide-on-close',
      order: 30,
      isButton: false,
      appendTo: 'root',
      html: '',
      onInit: (captionEl, pswp) => {
        const updateCaption = () => {
          const title = (pswp.currSlide && pswp.currSlide.data && pswp.currSlide.data.title) || ''; // webpack4が ?. を解釈できないため書き換え
          captionEl.innerHTML = title;
          captionEl.classList.toggle('pswp__caption--empty', !title);
        };

        pswp.on('change', updateCaption);
        updateCaption();
      }
    });
  });

  lightbox.init();
}
